export default function Title() {
    return(
        <h1 className="fs-4 fw-bold border-bottom border-white border-opacity-10">
                <p className="p-0 m-0">Mohamed Majid</p>
                <p className="text-white-50">Web Developer</p>
        </h1>
    )
}